import Marquee from "react-fast-marquee";
import { Droplet, Star, ArrowRight } from "lucide-react";

const STARS = [1, 2, 3, 4, 5];

const GOOGLE_REVIEWS_URL = "https://share.google/LEsF23vYmK87fVZXX";

const quotes = [
  { text: "Blooming amazing!! Happy Tiddlers, it's not just a swimming lesson, it's a family — the love and care for the young ones is unbelievable!!", name: "Rupal" },
  { text: "Such a nurturing environment. It feels like they really enjoy getting to know the children and their families. Would definitely recommend (lovely warm water too!)", name: "Marie" },
  { text: "A wonderful, supportive team who have created such a lovely community for the little ones.", name: "James" },
  { text: "Best place on earth. My son started swimming here at 8 weeks old — he's now 2.5 and loves this place and the people. His confidence in the water is amazing.", name: "Katie" },
  { text: "All the staff at Happy Tiddlers are always so friendly and incredibly skilled at what they do. Lessons are always well thought out to ensure they are fun and engaging, but most importantly to teach the little ones how to swim.", name: "Jon" },
  { text: "I was looking for a supportive environment to start swimming with my 12 month old son. He's 7 now and he and his little sister are still loving coming to Tiddlers once a week. One of the most genuine and friendly kid-first businesses I've ever dealt with. All about building confidence in the water — and many family holidays enjoyed in the pool are the proof!", name: "Fred" },
  { text: "Can't speak highly enough of everyone at Happy Tiddlers. We have both our children coming for lessons (4 and 10 months) — both absolutely love it and we've really seen the confidence grow with our eldest. Always really helpful and professional!", name: "Joseph" },
  { text: "So happy we found Happy Tiddlers for our little one. Our son loves it and has become very confident in the water from such a young age. All the staff are super friendly and helpful! Highly recommended.", name: "Natalie" },
  { text: "A fabulous, friendly and fun pool. Staff are so caring and always make everyone feel welcome and safe. Thank you for always going the extra mile to make sure everyone is happy.", name: "Pat" },
  { text: "Have been taking our little boy for lessons since he was 3 months old (now 2.5) and he enjoys it every week. Super friendly staff and small groups, so it feels like you get 1-1 support. Would recommend to anyone local.", name: "Rebecca" },
  { text: "Thank you all, from the bottom of my splashy toes to the top of my heart, for all of the general life support you have provided me and my family — whalely more than just swimming teachers.", name: "Leanne" },
  { text: "We love Happy Tiddlers. My son really enjoys his lessons here and all the staff are amazing — lovely and helpful. It's like a little family. Thank you all xx", name: "Claire" },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 md:py-32 bg-[#0A2540] overflow-hidden" data-testid="testimonials-section">
      <div className="container mx-auto px-6 md:px-12 mb-14">
        <span className="text-sm text-[#38BDF8] tracking-[0.2em] uppercase font-bold">Family Reviews</span>
        <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight max-w-2xl">
          Loved by Barton-le-Clay families
        </h2>
        <a
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group mt-7 inline-flex items-center gap-3 bg-white text-[#0A2540] font-bold pl-5 pr-6 py-3 rounded-full hover:-translate-y-0.5 transition-all duration-300"
          data-testid="google-reviews-link"
        >
          <span className="flex items-center gap-0.5 text-[#FBBC04]">
            {STARS.map((n) => (
              <Star key={n} size={16} fill="#FBBC04" strokeWidth={0} />
            ))}
          </span>
          Read our Google reviews
          <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
        </a>
      </div>

      <Marquee gradient={false} speed={40} pauseOnHover>
        {quotes.map((q, i) => (
          <div key={q.name} className="flex items-center" data-testid={`testimonial-${i}`}>
            <span className="font-heading italic font-medium text-2xl md:text-4xl text-[#F1F5F9] px-8 md:px-12">
              "{q.text}"
              <span className="not-italic font-bold text-[#38BDF8] text-lg md:text-xl ml-3">— {q.name}</span>
            </span>
            <Droplet size={28} className="text-[#FF7A1A] shrink-0" fill="#FF7A1A" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
